var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_131_2997",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_131_2997",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACshmLzAAACKUlEQVRYCe2VPW4UQRCF18iCGAIT+gT83sEis7gAt0BI2EcATgGngJwQcwQ7dGICCEiwed9uv1F1b/VMywhIXFKpq95P9Xo83bOz2o7zbWhC7k/VWHFQZJ968p2EuEowQ5neXLui/VLAp1rn5lZehOReSGOVcKF5Id4+6uGwKRoyLPJtfUfAmdI+arChsCmKMyzybf1SAJ6vJanBhiLbLMN6w+6KuFDieVaSGgxuMbLNMqw36I0I9PHNpwaDW4xsswzLBu0L/Km8VD4JAmowODRVcO5jZpsZi7rsvnivWWg/VDtsGjA4NFV4eLtGUcu5j5rHarp/pbh9pZ8O2ik8zOfe/SRQYWxO87Ho3kZjU78rGrRTeLiBtgdvsbbnygX7pryn7AUcGrS+pheHM6zdMPZcuSdFc4Q4hN+ZAK2O1eDHs444DMC9zazG1oam5wPlW+9U9QOlo/U9FHGqBMdzW9kdbnNc0RPGNt1qxY/4XPDvWg8LEXVgcGBopy9rFAmvPkJ+6bzCE60HjLvex/CX6ldK66jB6NFU3wWLhA/HnOe1pnAcrfEKBrcVFmwRM8CS57m8P5TWUYOlYVFKdsARzyN5raPuhkVdQUKMehZ1u8nwP4Wyb0TEprefjbhE+JUE9WjMecz1ZlX7/I0n4I2rv1RgfArWrNfF/1Ol3jRznh6X4reS4f8UuvkBN0/gvz+BeA90z+k1j8XQvHgTXmef6lYrAzjvc1F5fgOUKOIJ9tZH4wAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService5);
export default __webpack_public_path__ + "static/media/service5.e92ac085438c1e7334bf6985f3eb9c6d.svg";
export { ForwardRef as ReactComponent };